import React, { useState } from 'react';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useForm } from 'react-hook-form';

//Modelos
import SearchUserModel from '../../models/SearchUser';

//Componentes
import Spinner from '../../components/spinner/Spinner';
import UsersList from './UsersList';

function UsersListContainer() {
    const {
        token,
        tablePage,
        SearchParameters,
        setTablePage,
        dispatchSearchParameters,
    } = useGlobalContext();
    const FormMethods = useForm();

    const [loader, setLoader] = useState(false);

    async function onSearch(data) {
        const UsersforSearch = new SearchUserModel(data);

        dispatchSearchParameters({
            type: 'USUARIOS',
            payload: {
                token,
                ...UsersforSearch,
                pagina: tablePage,
                cantidad: 10,
            },
        });

        setTablePage(1);
    }

    return loader ? (
        <Spinner />
    ) : (
        <UsersList
            functions={{
                ...FormMethods,
                onSearch,
            }}
            states={{
                SearchParameters,
            }}
        />
    );
}

export default UsersListContainer;
